export default "__VITE_ASSET__BpvIXi2B__"